module.exports = __webpack_public_path__ + "img/10x.b5caa9a0.png";